import { Table } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useHistory } from 'react-router-dom';
import { useLoadRecoveryPlans } from '../api';
import { PlanNameCell } from './PlanNameCell';
import { RecoveryPlanActionsMenu } from './RecoveryPlanActionsMenu';
import { useRecoveryPlanActions } from './use-recovery-plan-actions';
import { WorkflowsTable } from './WorkflowsTable';

const EDIT_PATH = '/settings/workflows/recovery-plans/edit';

export const RecoveryPlansTable = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { recoveryPlans = [], isRecoveryPlansLoading } = useLoadRecoveryPlans();
  const { setAsDefault, moveInvoices } = useRecoveryPlanActions(recoveryPlans);

  return (
    <WorkflowsTable
      columns={[
        t(i18nKeys.NAME),
        t(i18nKeys.SETTINGS.WORKFLOWS.STEPS),
        t(i18nKeys.CLIENTS),
        t(i18nKeys.INVOICES),
        t(i18nKeys.SETTINGS.WORKFLOWS.LAST_EDITED),
      ]}
      hasActions
      isLoading={isRecoveryPlansLoading}
    >
      {recoveryPlans.map(plan => (
        <Table.Tr
          key={plan.id}
          style={{ cursor: 'pointer' }}
          onClick={() => history.push(`${EDIT_PATH}/${plan.id}`)}
        >
          <PlanNameCell name={plan.name} isDefault={plan.isDefault} />
          <Table.Td>{plan.stepsCount}</Table.Td>
          <Table.Td>{plan.debtorsCount}</Table.Td>
          <Table.Td>{plan.invoicesCount}</Table.Td>
          <Table.Td>{plan.updatedAt.format('L')}</Table.Td>
          {/* The menu renders in a portal whose clicks still bubble to the row through React. */}
          <Table.Td onClick={event => event.stopPropagation()}>
            <RecoveryPlanActionsMenu
              plan={plan}
              onSetAsDefault={() => setAsDefault(plan)}
              onMoveInvoices={() => moveInvoices(plan)}
            />
          </Table.Td>
        </Table.Tr>
      ))}
    </WorkflowsTable>
  );
};
